module.exports = __webpack_public_path__ + "img/BannerClientesMobile.ba3f75ef.png";